import { createStore, createEvent } from 'effector';

export const $chatMessages = createStore([]);
export const $chatSocketConnection = createStore(null);

export const addChatMessage = createEvent();
export const setChatMessages = createEvent();
export const setChatSocketConnection = createEvent();
export const editChatMessage = createEvent();
export const deleteChatMessage = createEvent();

$chatMessages
    .on(addChatMessage, (state, newMessage) => [...state, newMessage])
    .on(editChatMessage, (state, updatedMessage) => state.map(msg => msg.id === updatedMessage.id ? updatedMessage : msg))
    .on(deleteChatMessage, (state, messageId) => state.filter(msg => msg.id !== messageId))
    .on(setChatMessages, (_, value) => value);

$chatSocketConnection
    .on(setChatSocketConnection, (_, value) => value);